<template>
    <div>
        <section>
            <!-- Navigation Header -->
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ 6 }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / 6) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Basic Information -->
                <!-- Medical History -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any of these medical conditions?</div>
                        <div class="form-subs">Please check all that apply. This helps us ensure your safety.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateMedicalHistory">
                                <div class="disclaimer-box">
                                    <div class="div-block-1488">
                                        <div class="text-block-538">!</div>
                                    </div>
                                    <p class="paragraph-102">These conditions may affect your eligibility for methylene blue treatment.</p>
                                </div>
                                <input type="submit" data-wait="Please wait..." class="form-button none w-button" value="None (Best Answer) ->">
                                <div v-for="condition in medicalConditions" :key="condition.id" class="checkbox-field-15 w-clearfix">
                                    <label class="w-checkbox">
                                        <input type="checkbox" 
                                               v-model="patient.medicalHistory" 
                                               :value="condition.id" 
                                               class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label">{{ condition.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Pregnancy Question -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently pregnant, planning to become pregnant, or breastfeeding?</div>
                        <div class="form-subs">This information is crucial for your safety.</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="setPregnancyStatus('Yes')" class="button-68 w-button">YES</a>
                                <a href="#" @click.prevent="setPregnancyStatus('No')" class="button-68 w-button">NO</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Medications -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you taking any of these medications?</div>
                        <div class="form-subs">Select all that apply. These medications may interact with methylene blue.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateMedications">
                                <div v-for="med in medications" :key="med.id" class="checkbox-field-15 w-clearfix">
                                    <label class="w-checkbox">
                                        <input type="checkbox" 
                                               v-model="patient.currentMedications" 
                                               :value="med.id" 
                                               class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label">{{ med.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Contact Information -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">How can we reach you?</div>
                        <div class="form-subs">We'll use this to send your consultation results and any follow-up information.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateContact">
                                <div class="phone-entry-div felix">
                                    <input class="phone-number-field-3 _1 form w-input" maxlength="3" @keyup="focusNext" v-model="patient.phone.part1" placeholder="(000)" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 form w-input" maxlength="3" @keyup="focusNext" v-model="patient.phone.part2" placeholder="000" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 _2 form w-input" maxlength="4" @keyup="focusNext" v-model="patient.phone.part3" placeholder="0000" type="text" required>
                                </div>
                                <input class="text-field-47 email form w-input" maxlength="256" v-model="patient.email" placeholder="Email Address" type="email" required>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Consent -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">Please review and acknowledge the informed consent</div>
                        <div class="consent-text">
                            <div class="form-subs consonent-box" v-html="consentText"></div>
                        </div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateConsent">
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" v-model="patient.consent" class="w-checkbox-input checkbox-11" required>
                                    <span class="checkbox-label-12 w-form-label">I have read and understand the informed consent statement</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="I Agree ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Final Summary -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Thank you for completing the screening</div>
                        <div class="form-subs">We'll review your information and contact you soon.</div>
                        <div class="summary-box">
                            <h3>Next Steps:</h3>
                            <ol>
                                <li>Our healthcare team will review your information</li>
                                <li>You'll receive an email confirmation</li>
                                <li>A healthcare provider will contact you within 24 hours</li>
                            </ol>
                        </div>
                        <div class="felix-form-block w-form">
                            <button @click="submitForm" class="form-button w-button" :disabled="loading">
                                {{ loading ? 'Submitting...' : 'Complete Screening' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>
export default {
    name: 'MethyleneBlueForm',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            loading: false,
            medicalConditions: [
                { id: 'g6pd', label: 'G6PD deficiency (Glucose-6-Phosphate Dehydrogenase Deficiency)' },
                { id: 'kidney', label: 'Advanced Kidney Disease (Chronic Kidney Disease)' },
                { id: 'liver', label: 'Liver disease (Liver cirrhosis)' },
                { id: 'anemia', label: 'Severe anemia' },
                { id: 'heart', label: 'Heart disease (e.g., arrhythmias, heart failure)' },
                { id: 'methemoglobinemia', label: 'Methemoglobinemia or history of low oxygen levels in the blood' },
                { id: 'None of the above', label: 'None of the above' },
            ],
            medications: [
                { id: 'ssri', label: 'Antidepressants (SSRIs, MAOIs, SNRIs)' },
                { id: 'anxiety', label: 'Anti-anxiety medications' },
                { id: 'parkinsons', label: 'Medications for Parkinson\'s disease' },
                { id: 'None of the above', label: 'None of the above' },
            ],
            patient: {
                firstName: '',
                lastName: '',
                dob: {
                    month: '',
                    day: '',
                    year: ''
                },
                medicalHistory: [],
                pregnancyStatus: null,
                currentMedications: [],
                phone: {
                    part1: '',
                    part2: '',
                    part3: ''
                },
                email: '',
                consent: false
            },
            consentText: `Methylene blue is a medication that may be prescribed for anti-aging purposes. It is important to note that while methylene blue is FDA-approved for other uses, such as treating methemoglobinemia, its application for anti-aging is considered off-label. This means it is not specifically approved by the FDA for this purpose, although your healthcare provider may prescribe it if deemed appropriate. The purpose of this consent form is to ensure you understand the reasons for using methylene blue, the potential benefits and risks, the monitoring plan, and your responsibilities during treatment. Please read this document carefully. <br/><br/>
                        Methylene blue is being considered as a treatment option to enhance mitochondrial function and reduce oxidative stress, key factors in the aging process. This medication works by improving electron transport within mitochondria, increasing cellular energy production (ATP), and reducing the accumulation of reactive oxygen species (ROS). By doing so, methylene blue may help delay cellular aging and improve overall tissue health. It also plays a crucial role in potentially improving skin health by stimulating collagen and elastin production, enhancing cognitive function through its neuroprotective effects, and boosting energy levels due to improved mitochondrial efficiency.<br/><br/>
                        As previously mentioned, the use of methylene blue for anti-aging purposes is considered off-label. While the medication is legally prescribed, its use differs from the original FDA-approved indications. The potential benefits of methylene blue may include improved skin appearance, with reductions in fine lines and wrinkles, increased skin elasticity, and enhanced hydration. Other benefits may include enhanced mitochondrial function, leading to improved vitality and reduced fatigue, reduced oxidative stress, neuroprotective effects for cognitive health and memory, and delaying cellular aging.<br/><br/>
                        Like all medications, methylene blue comes with potential risks and side effects. Common side effects may include headaches, nausea or vomiting, diarrhea, dizziness, abdominal discomfort, and blue or green discoloration of urine or bodily fluids. More serious but less common risks include severe allergic reactions, serotonin syndrome (especially when taken with certain antidepressants), hemolytic anemia (particularly in individuals with glucose-6-phosphate dehydrogenase (G6PD) deficiency), and methemoglobinemia, a condition where oxygen delivery to tissues is impaired.<br/><br/>
                        To ensure your safety and the effectiveness of the treatment, regular monitoring is required. You will undergo regular evaluations to determine whether the medication is improving your condition and to monitor for any side effects or adverse reactions. Scheduled follow-up visits will help discuss your progress, address concerns, and adjust your treatment plan as necessary.<br/><br/>
                        You have the right to discuss alternative treatments with your healthcare provider. These alternatives may include lifestyle modifications, such as regular physical exercise, a balanced diet rich in antioxidants, adequate sleep, stress management techniques, smoking cessation, and limiting alcohol consumption.<br/><br/>
                        As a patient, you are responsible for attending all scheduled follow-up appointments, reporting any side effects or new symptoms to your healthcare provider, adhering to the prescribed dosing regimen, informing your healthcare provider of all medications and supplements you're taking. You should also avoid contraindicated substances or medications while on methylene blue.<br/><br/>
                        By signing this consent form, you confirm that you have read and understood the information provided. You have had the opportunity to ask questions, and all of your questions have been answered to your satisfaction. You understand the potential risks and benefits of using methylene blue, including its off-label nature, and agree to adhere to the monitoring plan. You also agree to inform your healthcare provider of any side effects or concerns. By signing below, you voluntarily consent to the use of methylene blue for the treatment of your symptoms.<br/><br/>
                        `
        }
    },
    methods: {
        nextQuestion() {
            this.questionId++
            this.scrollToTop()
        },
        validateMedicalHistory() {
            // If any serious conditions are selected, show warning or redirect
            if(this.patient.medicalHistory.includes("None of the above")){
                this.nextQuestion()
            }else if (this.patient.medicalHistory.length > 0) {
                this.disqualifyPatient()
            } else {
                this.nextQuestion()
            }
        },
        setPregnancyStatus(status) {
            this.patient.pregnancyStatus = status
            if (status === 'Yes') {
                this.disqualifyPatient()
            } else {
                this.nextQuestion()
            }
        },
        validateMedications() {
            // Check for contraindicated medications
            if(this.patient.currentMedications.includes("None of the above")){
                this.nextQuestion()
            }else if (this.patient.currentMedications.length > 0) {
                this.disqualifyPatient()
            } else {
                this.nextQuestion()
            }
        },
        validateContact() {
            // Add phone and email validation logic
            this.nextQuestion()
        },
        validateConsent() {
            if (this.patient.consent) {
                this.nextQuestion()
            }
        },
        disqualifyPatient() {
            // Redirect to disqualification page
            this.$router.push('/sorry')
        },
        focusNext(event) {
            const maxLength = event.target.maxLength
            const currentLength = event.target.value.length
            if (currentLength >= maxLength) {
                const form = event.target.form
                const index = Array.prototype.indexOf.call(form, event.target)
                form.elements[index + 1]?.focus()
            }
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        async submitForm() {
            if (this.patient.consent === 'decline') {
                this.$router.push({ name: 'declined' });
                return;
            }

            this.loading = true;
            try {
                const formattedData = {
                    formObj: {
                        consentsSigned: this.patient.consent === 'accept',

                        // Format Q&A pairs with full questions and available options
                        Q1: "Please describe your current symptoms and health concerns.",
                        A1: this.patient.currentSymptoms || "None provided",

                        Q2: "Have you been diagnosed with any skin conditions, wound healing issues, or hair loss disorders? Available Options: Yes, No",
                        A2: `${this.patient.hasSkinConditions}${this.patient.hasSkinConditions === 'Yes' ? 
                            ': ' + this.patient.skinConditionsDetails : ''}`,

                        Q3: "Are you experiencing symptoms such as delayed wound healing, signs of skin aging (e.g., wrinkles, loss of elasticity), hair thinning, or hair loss? Available Options: Yes, No",
                        A3: this.patient.hasSymptoms,

                        Q4: "Are you currently on any treatments or medications for skin conditions, wound healing, or hair loss? Available Options: Yes, No",
                        A4: `${this.patient.onTreatments}${this.patient.onTreatments === 'Yes' ? 
                            ': ' + this.patient.treatmentsDetails : ''}`,

                        Q5: "Have you ever used GHK-Cu (Copper Peptide) or other peptide-based therapies before? Available Options: Yes, No",
                        A5: `${this.patient.priorPeptideUse}${this.patient.priorPeptideUse === 'Yes' ? 
                            ': ' + this.patient.priorPeptideDetails : ''}`,

                        Q6: "Do you have a history of allergic reactions to peptides, copper, or any topical products? Available Options: Yes, No",
                        A6: `${this.patient.hasAllergies}${this.patient.hasAllergies === 'Yes' ? 
                            ': ' + this.patient.allergiesDetails : ''}`,

                        Q7: "Do you have any known copper metabolism disorders, such as Wilson's disease or Menkes disease? Available Options: Yes, No",
                        A7: `${this.patient.hasMetabolismDisorders}${this.patient.hasMetabolismDisorders === 'Yes' ? 
                            ': ' + this.patient.metabolismDisordersDetails : ''}`,

                        Q8: "Do you have any kidney or liver conditions? Available Options: Yes, No",
                        A8: `${this.patient.hasOrganConditions}${this.patient.hasOrganConditions === 'Yes' ? 
                            ': ' + this.patient.organConditionsDetails : ''}`,

                        Q9: "Are you pregnant, planning to become pregnant, or currently breastfeeding? Available Options: Yes, No",
                        A9: this.patient.isPregnant,

                        Q10: "Please describe your current skincare or hair care routine, including any products or supplements you are using.",
                        A10: this.patient.skinCareRoutine || "None provided",

                        Q11: "Do you use tobacco, alcohol, or recreational drugs? Available Options: Yes, No",
                        A11: `${this.patient.useSubstances}${this.patient.useSubstances === 'Yes' ? 
                            ': ' + this.patient.substanceDetails : ''}`,

                        Q12: "Do you have a balanced diet that includes sources of essential nutrients and antioxidants? Available Options: Yes, No",
                        A12: `${this.patient.hasBalancedDiet}${this.patient.hasBalancedDiet === 'No' ? 
                            ': ' + this.patient.dietaryDetails : ''}`,

                        Q13: "Informed Consent Acknowledgment. Available Options: Accept, Decline",
                        A13: this.patient.consent === 'accept' ? "Patient has acknowledged and consented" : "Patient has declined consent"
                    },
                    patientInfo: {
                        submissionDate: new Date().toISOString()
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "ghk-cu"
                };

                const response = await this.$axios.post(
                    `${this.baseUrl}/forms/assessment-form/ghk-cu-screening/${this.$route.params.id}`, 
                    formattedData
                );

                if (response.data.status === 'success') {
                    this.$router.push('/home');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (error) {
                console.error('Form submission error:', error);
                alert('There was an error submitting your form. Please try again.');
            } finally {
                this.loading = false;
            }
        },
        showError(message) {
            // Implement error display logic
            alert(message) // Replace with more sophisticated error handling
        },
        validateAge() {
            const birthDate = new Date(
                this.patient.dob.year,
                parseInt(this.patient.dob.month) - 1,
                this.patient.dob.day
            )
            const today = new Date()
            let age = today.getFullYear() - birthDate.getFullYear()
            const monthDiff = today.getMonth() - birthDate.getMonth()
            
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--
            }
            
            return age >= 18 && age <= 75
        },
        validateEmail(email) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            return regex.test(email)
        },
        validatePhone() {
            const phone = this.patient.phone
            return phone.part1.length === 3 && 
                   phone.part2.length === 3 && 
                   phone.part3.length === 4 &&
                   /^\d+$/.test(phone.part1 + phone.part2 + phone.part3)
        }
    },
    computed: {
        formProgress() {
            return Math.round((this.questionId / 7) * 100)
        },
        isFormValid() {
            return this.patient.consent && 
                   this.validatePhone() && 
                   this.validateEmail(this.patient.email) &&
                   this.validateAge()
        }
    },
    watch: {
        questionId() {
            this.scrollToTop()
        }
    },
    mounted() {
        this.scrollToTop()
    }
}
</script>
<style scoped>
textarea.w-input, textarea.w-select {
    height: auto;
    width: 100%;
}

.multi-choice-boxes-div {
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
}

.checkbox-field-multibox {
    border: 1px solid #000;
    border-radius: 9px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 48%;
    height: 160px;
    padding: 19px 13px;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
}

.checkbox-13-check {
    border: 1px #000;
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-left: 0;
    position: absolute;
    inset: 0%;
}

.image-384 {
    width: 55px;
    height: 55px;
    margin-bottom: 10px;
    position: relative;
}

.checkbox-label-14-check {
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    margin-top: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    position: relative;
}

.w-checkbox:after {
    content: " ";
    clear: both;
    grid-area: 1 / 1 / 2 / 2;
    display: table;
}

/* Add mobile responsiveness */
@media screen and (max-width: 479px) {
    .checkbox-field-multibox {
        width: 100%;
        margin-bottom: 10px;
    }
}
.consonent-box{
    height: 380px;
    overflow-y: auto;
}
</style>